import { ActionTypes as t } from "./businessModal.types.js";
const S = (e) => ({
  type: t.RESET_SELECTION,
  payload: e
}), E = (e) => ({
  type: t.SELECTED_BUSINESS,
  payload: e
}), c = (e) => ({
  type: t.SELECTED_GROUP,
  payload: e
}), o = () => ({
  type: t.SELECT_ALL
}), n = () => ({
  type: t.APPLY
}), p = (e) => ({
  type: t.SET_SEARCH_BUSINESS,
  payload: e
}), y = (e) => ({
  type: t.SET_SEARCH_CITY,
  payload: e
}), _ = (e) => ({
  type: t.SET_SEARCH_ORG,
  payload: e
}), r = (e) => ({
  type: t.SET_SEARCH_QUERY_ORGANIZATION,
  payload: e
});
export {
  n as apply,
  S as resetSelection,
  o as selectAll,
  E as selectBusiness,
  c as selectGroup,
  p as setSearchBusiness,
  y as setSearchCity,
  _ as setSearchOrg,
  r as setSearchQueryOrganization
};
